// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7d29205f","453":"36951e1f","667":"737be14c","977":"1197e902"}[chunkId] + ".chunk.js";
};